import { render, staticRenderFns } from "./GlyphLevelsAndWeights.vue?vue&type=template&id=3dfb3588&scoped=true"
import script from "./GlyphLevelsAndWeights.vue?vue&type=script&lang=js"
export * from "./GlyphLevelsAndWeights.vue?vue&type=script&lang=js"
import style0 from "./GlyphLevelsAndWeights.vue?vue&type=style&index=0&id=3dfb3588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfb3588",
  null
  
)

export default component.exports